function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m256.2 358.5c2.5 0 5-.9 7.5-3.4l89.1-88.4c1.9-1.9 3.1-4 3.1-6.9 0-5.3-4.4-9.3-9.7-9.3-2.5 0-5.6 1.2-7.5 3.1l-45.8 46.7-27.1 27.7.6-34.3v-283.4c0-5.6-4.7-10.3-10.3-10.3-5.9 0-10.6 4.7-10.6 10.3v283.4l.6 34.6-27.1-28-46-46.8c-1.9-1.9-5-3.1-7.5-3.1-5.3 0-9.3 4-9.3 9.3 0 2.8.9 5 3.1 6.9l89.4 88.4c2.2 2.5 4.7 3.5 7.5 3.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m115.1 512h281.8c44.2 0 67.3-23.4 67.3-67v-255.3c0-43.6-23-67-67.3-67h-71v21.2h70.4c29.9 0 46.7 15.9 46.7 47v252.9c0 31.1-16.8 47-46.7 47h-280.6c-30.5 0-46.7-15.9-46.7-47v-252.9c0-31.1 16.2-47 46.7-47h71v-21.2h-71.6c-44.2 0-67.3 23-67.3 67v255.3c0 44.3 23.1 67 67.3 67z"
});

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.0a2d19d4.svg";
export { ForwardRef as ReactComponent };